var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiSelectedChatbotToolBookmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.91667H14.0833M0.75 2.41667V14.0833C0.75 15.4567 2.31794 16.2407 3.41667 15.4167L6.41667 13.1667C7.00926 12.7222 7.82408 12.7222 8.41667 13.1667L11.4167 15.4167C12.5154 16.2407 14.0833 15.4567 14.0833 14.0833V2.41667C14.0833 1.49619 13.3371 0.75 12.4167 0.75H2.41667C1.49619 0.75 0.75 1.49619 0.75 2.41667Z",
    stroke: "#5767DB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiSelectedChatbotToolBookmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_selected_chatbot_tool_bookmark.9d01b53de8bcc8d4a66442d4f476788c.svg";